import { initializeApp } from 'firebase/app';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { getFirestore, collection, addDoc, getDocs, deleteDoc, doc } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCRJbaL5y1IkO-MvSLfl56eAIbCdJ6uQy8",
  authDomain: "samriddhi-health.firebaseapp.com",
  projectId: "samriddhi-health",
  storageBucket: "samriddhi-health.firebasestorage.app",
  messagingSenderId: "850622578053",
  appId: "1:850622578053:web:721879139660de4bd858ec",
  measurementId: "G-4BDJ4WDBC9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const db = getFirestore(app);

// Upload logo to Firebase Storage
export const uploadLogoToFirebase = async (file, partnerName) => {
  try {
    const timestamp = Date.now();
    const fileName = `partners/${partnerName.toLowerCase().replace(/\s+/g, '-')}-${timestamp}.${file.name.split('.').pop()}`;
    const storageRef = ref(storage, fileName);
    
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

// Delete logo from Firebase Storage
export const deleteLogoFromFirebase = async (logoUrl) => {
  try {
    const storageRef = ref(storage, logoUrl);
    await deleteObject(storageRef);
  } catch (error) {
    console.error('Error deleting file:', error);
    throw error;
  }
};

// Save partner data to Firestore
export const savePartnerToFirebase = async (partnerData) => {
  try {
    const docRef = await addDoc(collection(db, 'partners'), partnerData);
    return docRef.id;
  } catch (error) {
    console.error('Error saving partner:', error);
    throw error;
  }
};

// Get all partners from Firestore
export const getPartnersFromFirebase = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, 'partners'));
    const partners = [];
    querySnapshot.forEach((doc) => {
      partners.push({
        id: doc.id,
        ...doc.data()
      });
    });
    return partners;
  } catch (error) {
    console.error('Error getting partners:', error);
    throw error;
  }
};

// Delete partner from Firestore
export const deletePartnerFromFirebase = async (partnerId) => {
  try {
    await deleteDoc(doc(db, 'partners', partnerId));
  } catch (error) {
    console.error('Error deleting partner:', error);
    throw error;
  }
};

// Upload claim form file to Firebase Storage
export const uploadClaimFormToFirebase = async (file, fileName, folder = 'claim-forms') => {
  try {
    const timestamp = Date.now();
    const fileExtension = file.name.split('.').pop();
    const fullFileName = `${folder}/${fileName}-${timestamp}.${fileExtension}`;
    const storageRef = ref(storage, fullFileName);
    
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error('Error uploading claim form file:', error);
    throw error;
  }
};

// Delete claim form file from Firebase Storage
export const deleteClaimFormFromFirebase = async (fileUrl) => {
  try {
    const storageRef = ref(storage, fileUrl);
    await deleteObject(storageRef);
  } catch (error) {
    console.error('Error deleting claim form file:', error);
    throw error;
  }
};

// Save claim form data to Firestore
export const saveClaimFormToFirebase = async (claimFormData) => {
  try {
    const docRef = await addDoc(collection(db, 'claimForms'), claimFormData);
    return docRef.id;
  } catch (error) {
    console.error('Error saving claim form:', error);
    throw error;
  }
};

// Get all claim forms from Firestore
export const getClaimFormsFromFirebase = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, 'claimForms'));
    const claimForms = [];
    querySnapshot.forEach((doc) => {
      claimForms.push({
        id: doc.id,
        ...doc.data()
      });
    });
    return claimForms.sort((a, b) => a.companyName.localeCompare(b.companyName));
  } catch (error) {
    console.error('Error getting claim forms:', error);
    throw error;
  }
};

export { db, storage };
